import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';

const removeActiveDrawerPaneMutator: (tabId: string) => void = mutatorAction(
    'removeActiveDrawerPane',
    (tabId: string): void => {
        getStore().activePanes.delete(tabId);
    }
);
export default removeActiveDrawerPaneMutator;
